import { render, staticRenderFns } from "./QueueReport.vue?vue&type=template&id=167e89c4&"
import script from "./QueueReport.vue?vue&type=script&lang=js&"
export * from "./QueueReport.vue?vue&type=script&lang=js&"
import style0 from "./QueueReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports